import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      background:
        'linear-gradient(0deg, #F1F7FF 80%, rgba(241, 247, 255, 0) 100%)',
      height: '100px',
      position: 'fixed',
      bottom: 0,
      left: (props: { shopId: string | null }) => (props.shopId ? 0 : '280px'),
      right: 0,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '20px',
      zIndex: 100,
      '@media (max-width: 768px)': {
        display: 'none'
      }
    },
    mobileFooter: {
      marginBottom: '130px',
      marginTop: '20px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
